import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FileSpreadsheet, 
  DownloadCloud, 
  Star, 
  ShieldCheck, 
  ChevronRight, 
  ArrowLeft,
  HardDrive,
  Info
} from 'lucide-react';

/**
 * Card de Configuración Técnica - Diseño de Alta Densidad
 * Implementa bordes de colores completos y un layout horizontal limpio.
 */
const ConfigCard = ({ icon: Icon, title, desc, color, onClick }) => (
  <div 
    onClick={onClick} 
    className="group bg-white p-5 rounded-2xl border-2 transition-all cursor-pointer flex items-center gap-5 shadow-sm hover:shadow-md hover:scale-[1.01] active:scale-[0.99]"
    style={{ borderColor: color }}
  >
    {/* Contenedor del Icono con fondo suavizado (opacidad 15%) */}
    <div 
      className="w-16 h-16 rounded-2xl flex items-center justify-center shrink-0 transition-transform group-hover:scale-110"
      style={{ backgroundColor: `${color}15`, color: color }}
    >
      <Icon size={32} strokeWidth={2.5} />
    </div>
    
    <div className="flex-1 min-w-0">
      <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-1">
        {title}
      </h3>
      <p className="text-[13px] font-black text-slate-800 uppercase tracking-tight leading-tight">
        {desc}
      </p>
    </div>

    <div className="p-2 text-slate-200 group-hover:text-slate-400 transition-colors">
      <ChevronRight size={20} />
    </div>
  </div>
);

function ConfigSistema() {
  const navigate = useNavigate();

  return (
    <div className="w-full min-h-screen bg-[#F8FAFC] font-sans text-slate-700 p-4 md:p-6 lg:p-8 animate-nova-in">
      
      {/* HEADER TÉCNICO - ESTILO PRODUCTOS */}
      <header className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-10 px-1">
        <div className="flex items-center gap-3">
          <button 
            onClick={() => navigate('/sistema/configuracion')}
            className="p-2.5 bg-white border border-slate-200 rounded-xl text-slate-400 hover:text-[#51A7FD] shadow-sm transition-all hover:scale-105 active:scale-95"
          >
            <ArrowLeft size={20} />
          </button>
          <div>
            <h1 className="text-xl font-black text-slate-800 uppercase tracking-tight leading-none italic">Sistema y Datos</h1>
            <p className="text-[9px] font-bold text-slate-400 uppercase tracking-[0.2em] mt-1.5 italic">Protocolos de mantenimiento e infraestructura cloud</p>
          </div>
        </div>

        <div className="flex items-center gap-3 px-6 py-2.5 bg-blue-50 text-[#51A7FD] rounded-2xl border border-blue-100 shadow-inner">
          <HardDrive size={16} />
          <span className="text-[10px] font-black uppercase tracking-widest text-blue-600">Almacenamiento Cloud Activo</span>
        </div>
      </header>

      {/* MATRIZ DE MANTENIMIENTO TÉCNICO (Sin KPIs Superiores) */}
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          <ConfigCard 
            icon={FileSpreadsheet} 
            title="Catálogos Maestros" 
            desc="Importar Datos" 
            color="#10b981" // Verde para operaciones de entrada
            onClick={() => navigate('/sistema/config-sistema-importar')} // Navegación al Importador Maestro
          />
          <ConfigCard 
            icon={DownloadCloud} 
            title="Respaldos Técnicos" 
            desc="Exportar Datos" 
            color="#3b82f6" // Azul para backups
            onClick={() => {}} 
          />
          <ConfigCard 
            icon={Star} 
            title="Estatus de Plan" 
            desc="Mi Suscripción" 
            color="#f59e0b" // Ámbar para suscripciones
            onClick={() => {}} 
          />
          <ConfigCard 
            icon={ShieldCheck} 
            title="Auditoría de Eventos" 
            desc="Logs de Sistema" 
            color="#ef4444" // Rojo para seguridad
            onClick={() => navigate('/sistema/logs')} 
          />
        </div>
      </div>

      {/* NOTA TÉCNICA INFERIOR */}
      <div className="mt-12 p-6 bg-blue-50/30 rounded-[2rem] border border-blue-100 flex items-center gap-5 max-w-4xl shadow-sm">
        <Info size={24} className="text-[#51A7FD] shrink-0" />
        <p className="text-[10px] font-bold text-blue-600 uppercase leading-relaxed tracking-tight italic">
          Las herramientas de base de datos deben utilizarse siguiendo las plantillas oficiales para evitar inconsistencias en la integridad de la información centralizada de la organización.
        </p>
      </div>

      <style>{`
        .animate-nova-in { animation: novaFadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
        @keyframes novaFadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </div>
  );
}

export default ConfigSistema;